import { SET_IS_NEW_RECORD } from '../actionTypes';
import { actions } from '../reducer';

export default (value) => actions[SET_IS_NEW_RECORD](value);
